import {
  MOVE_TO_MAIN_PAGE,
  LOGIN_PAGE,
  MAIN_PAGE,
  MOVE_TO_LOGIN_PAGE,
  MOVE_TO_SIGN_UP_PAGE,
  SIGN_UP_PAGE,
  MOVE_TO_VALIDATE_PAGE,
  VALIDATE_PAGE,
  MOVE_TO_FORGOTTEN_PAGE,
  FORGOTTEN_PAGE,
  MOVE_TO_FORGOTTEN_PAGE_RESET,
  FORGOTTEN_PAGE_RESET,
  MOVE_TO_OPTIONS_PAGE,
  OPTIONS_PAGE,
  MOVE_TO_RESET_PASSWORD_PAGE,
  RESET_PASSWORD_PAGE,
  MOVE_TO_DELETE_ACCOUNT_PAGE,
  DELETE_ACCOUNT_PAGE,
} from "../actions/routeactions";

const initialState = {
  pageNo: LOGIN_PAGE,
  args: [],
};

export function routeReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case MOVE_TO_MAIN_PAGE:
      nextState.pageNo = MAIN_PAGE;
      nextState.args = [action.doLoad];
      return nextState;
    case MOVE_TO_LOGIN_PAGE:
      nextState.pageNo = LOGIN_PAGE;
      return nextState;
    case MOVE_TO_SIGN_UP_PAGE:
      nextState.pageNo = SIGN_UP_PAGE;
      return nextState;
    case MOVE_TO_VALIDATE_PAGE:
      nextState.pageNo = VALIDATE_PAGE;
      return nextState;
    case MOVE_TO_FORGOTTEN_PAGE:
      nextState.pageNo = FORGOTTEN_PAGE;
      return nextState;
    case MOVE_TO_FORGOTTEN_PAGE_RESET:
      nextState.pageNo = FORGOTTEN_PAGE_RESET;
      nextState.args = [action.email, action.securityQuestion];
      return nextState;
    case MOVE_TO_OPTIONS_PAGE:
      nextState.pageNo = OPTIONS_PAGE;
      return nextState;
    case MOVE_TO_RESET_PASSWORD_PAGE:
      nextState.pageNo = RESET_PASSWORD_PAGE;
      return nextState;
    case MOVE_TO_DELETE_ACCOUNT_PAGE:
      nextState.pageNo = DELETE_ACCOUNT_PAGE;
      return nextState;
    default:
      return state;
  }
}
